import { provideHttpClient, withFetch } from "@angular/common/http";
import {
    ApplicationConfig,
    inject,
    isDevMode,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZonelessChangeDetection
} from "@angular/core";
import { provideClientHydration, withIncrementalHydration } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { provideTransloco } from "@jsverse/transloco";
import { provideHotToastConfig } from "@ngxpert/hot-toast";
import { provideAngularSvgIcon } from "angular-svg-icon";
import { provideNgxMask } from "ngx-mask";
import { LanguagePreloadService } from "../common/i18n/language-preloader.service";
import { availableLanguages } from "../common/i18n/transloco/available-languages";
import { TranslocoHttpLoader } from "../common/i18n/transloco/transloco-loader";
import { environment } from "../environments/environment";
import { provideApi } from "./api/api-provider";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideClientHydration(withIncrementalHydration()),
        provideHttpClient(withFetch()),
        provideApi({
            rootUrl: environment.directusUrl
        }),
        provideHotToastConfig({ position: "bottom-right" }),
        provideNgxMask(),
        provideTransloco({
            config: {
                availableLangs: availableLanguages,
                defaultLang: "fr",
                reRenderOnLangChange: true,
                prodMode: !isDevMode()
            },
            loader: TranslocoHttpLoader
        }),
        provideAppInitializer(() => {
            const service = inject(LanguagePreloadService);
            return service.preload();
        }),
        provideAngularSvgIcon()
    ]
};
